import React, { FC } from 'react';

import styled from '@emotion/styled';
import {
  layout,
  LayoutProps,
  space,
  SpaceProps,
  BorderProps,
  border,
  compose
} from '@lucid/theme';

export interface SpacerProps extends LayoutProps, SpaceProps, BorderProps {
  /** Allows the component to get additional styles. */
  className?: string;
}

const spacerStyleProp = compose(border, layout, space);

const StyledSpacer = styled.div<SpacerProps>(
  {
    width: '100%'
  },
  spacerStyleProp
);

const Spacer: FC<SpacerProps> = ({ className, ...rest }) => (
  <StyledSpacer {...rest} className={className} />
);

export { Spacer };
export default Spacer;
